import { render, staticRenderFns } from "./ActionTypeComponent.vue?vue&type=template&id=24d0a906&"
import script from "./ActionTypeComponent.vue?vue&type=script&lang=ts&"
export * from "./ActionTypeComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d0a906')) {
      api.createRecord('24d0a906', component.options)
    } else {
      api.reload('24d0a906', component.options)
    }
    module.hot.accept("./ActionTypeComponent.vue?vue&type=template&id=24d0a906&", function () {
      api.rerender('24d0a906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/Elements/ActionTypeComponent.vue"
export default component.exports